import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    padding: theme.spacing(1.115, 2),
  },
  text: {
    paddingLeft: theme.spacing(0.75),
  },
}));

export default useStyles;
